import clsx from 'clsx';

type TRowContainerProps = {
  children: React.ReactNode;
  className?: string;
};

export function RowContainer({ children, className }: TRowContainerProps) {
  return (
    <div className={clsx('flex w-full flex-wrap gap-4 md:flex-nowrap', className)}>{children}</div>
  );
}
